import React from "react";
import { connect } from "react-redux";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import ExportJsonExcel from "js-export-excel";
import helpersNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";

function AllPagesSitePublisher({
  dataSitePublisher,
  nameCategory,
  startDate,
  endDate,
}) {
  const getTypeDate = (dateString) => {
    const dateStringSplit = dateString.split("");
    const yearSplit = dateStringSplit[0] + dateStringSplit[1];
    if (yearSplit == "20") {
      return "gregorian";
    } else if (yearSplit == "14") {
      return "Jalali";
    }
  };

  const exportReportExcel = () => {
    const newDataSitePublisher = { ...dataSitePublisher };

    if (getTypeDate(startDate) == "gregorian") {
      startDate = helpersTime.convertGregorianToJalali(startDate);
    }

    if (getTypeDate(endDate) == "gregorian") {
      endDate = helpersTime.convertGregorianToJalali(endDate);
    }

    var option = new Object();
    option.fileName =
      nameCategory == "" ? "گزارش سایت های انتخاب شده" : nameCategory;
    let dataExcelFile = [
      {
        one: "عنوان گروه ",
        two: nameCategory + "",
      },
      {
        one: "مبلغ گروه نمایش دهنده",
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceCategoryUserSitePublisher(newDataSitePublisher)
          )
        ),
      },
      {
        one: "تاریخ شروع",
        two: helpersNumbers.toPersianNum(startDate),
        three: "تاریخ پایان",
        four: helpersNumbers.toPersianNum(endDate),
      },
      {
        one: "=======================",
        two: "=======================",
      },
    ];

    for (let key in newDataSitePublisher) {
      dataExcelFile = [
        ...dataExcelFile,
        ...generateEachSitePublisherArrayReportExportExcel(
          newDataSitePublisher[key]
        ),
        {
          one: "=======================",
          two: "=======================",
        },
      ];
    }

    option.datas = [
      {
        sheetData: dataExcelFile,
        columnWidths: [10, 10],
      },
    ];

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
    dataExcelFile = [];
  };

  const generatePageDataReportExportExcel = (pageDataReport) => {
    return [
      {
        one: pageDataReport.title,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(pageDataReport.price)
        ),
      },
      { ...pageDataReport.positions },
      { one: "", two: "" },
    ];
  };

  const getPriceSitePublisher = (priceSitePublisher) => {
    let pricePage = 0;
    const newSitePublisherData = { ...priceSitePublisher };
    for (const key in newSitePublisherData) {
      if (key === "url") {
        continue;
      }
      pricePage = pricePage + newSitePublisherData[key].price;
    }
    return pricePage;
  };

  const getPriceCategoryUserSitePublisher = (sitePublisherData) => {
    let priceCategoryUserSitePublisher = 0;
    for (let key in sitePublisherData) {
      priceCategoryUserSitePublisher += getPriceSitePublisher(
        sitePublisherData[key]
      );
    }
    return priceCategoryUserSitePublisher;
  };

  const generateEachSitePublisherArrayReportExportExcel = (
    sitePublisherDataParam
  ) => {
    let sitePublisherUrl = sitePublisherDataParam.url;

    let dataEachSitePublisherExcelFile = [
      {
        one: sitePublisherUrl,
        two: helpersNumbers.toPersianNum(
          helpersNumbers.toFormatFinanceNumber(
            getPriceSitePublisher(sitePublisherDataParam)
          )
        ),
      },
    ];

    for (const key in sitePublisherDataParam) {
      if (key === "url") {
        continue;
      }

      const item = sitePublisherDataParam[key];
      dataEachSitePublisherExcelFile = [
        ...dataEachSitePublisherExcelFile,
        ...generatePageDataReportExportExcel(item),
      ];
    }

    return dataEachSitePublisherExcelFile;
  };

  const popover = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      <span style={{ fontFamily: "IRANSansWeb" }}>
        گزارش انتخاب جایگاه ها بصورت فایل excel
      </span>
    </Tooltip>
  );

  return (
    <>
      <OverlayTrigger
        trigger="hover"
        rootClose
        placement="top"
        overlay={popover}
      >
        <div
          className="position-fixed"
          id="export-excel-category-user-site-publisher"
        >
          <span
            className="btn btn-success rounded-circle"
            onClick={exportReportExcel}
          >
            <i className="fa fa-file-excel"></i>
          </span>
        </div>
      </OverlayTrigger>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    dataSitePublisher: state.categoryUserSitePublisher.data_site_publisher,
    nameCategory: state.categoryUserSitePublisher.name_category,
    startDate: state.categoryUserSitePublisher.start_date,
    endDate: state.categoryUserSitePublisher.end_date,
  };
};

export default connect(mapStateToProps)(AllPagesSitePublisher);
